import { Action } from 'redux';
import { BffCmsHeaderBannersResponse } from '@lucky7ventures/bff-types';

export enum HeaderBannersActionType {
  GetHeaderBanners = 'GET_HEADERBANNERS',
  GetHeaderBannersSuccess = 'GET_HEADERBANNERS_SUCCESS',
  GetHeaderBannersError = 'GET_HEADERBANNERS_ERROR',
}

export type GetHeaderBannersAction = Action<HeaderBannersActionType.GetHeaderBanners>;
export type GetHeaderBannersSuccessAction =
  Action<HeaderBannersActionType.GetHeaderBannersSuccess> & {
    headerBanners: BffCmsHeaderBannersResponse;
  };
export type GetHeaderBannersErrorAction = Action<HeaderBannersActionType.GetHeaderBannersError>;

export type HeaderBannersActions =
  | GetHeaderBannersAction
  | GetHeaderBannersSuccessAction
  | GetHeaderBannersErrorAction;

export const getHeaderBanners = (): GetHeaderBannersAction => ({
  type: HeaderBannersActionType.GetHeaderBanners,
});

export const getHeaderBannersSuccess = (
  headerBanners: BffCmsHeaderBannersResponse,
): GetHeaderBannersSuccessAction => ({
  type: HeaderBannersActionType.GetHeaderBannersSuccess,
  headerBanners,
});

export const getHeaderBannersError = (): GetHeaderBannersErrorAction => ({
  type: HeaderBannersActionType.GetHeaderBannersError,
});
